import { render, staticRenderFns } from "./CollectionTile.vue?vue&type=template&id=3e0d6896"
import script from "./CollectionTile.vue?vue&type=script&lang=js"
export * from "./CollectionTile.vue?vue&type=script&lang=js"
import style0 from "./CollectionTile.vue?vue&type=style&index=0&id=3e0d6896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports